<header mat-dialog-title>
    <mat-icon color="accent">face</mat-icon>
    <h1 class="no-wrap">Bestätigung erforderlich</h1>
    <span class="spacer"></span>
</header>

<mat-dialog-content>
    <span>{{ text }}</span>
</mat-dialog-content>

<mat-dialog-actions>
    <mat-checkbox [(ngModel)]="isConfirmed">
        Ich bestätige
    </mat-checkbox>
    <div class="button-container">
        <button mat-button (click)="onCancel()">zurück</button>
        <button mat-raised-button
                color="primary"
                [disabled]="!isConfirmed"
                (click)="onConfirm()">
            fortfahren
        </button>
    </div>
</mat-dialog-actions>
